import { ReactElement, useRef, useState } from 'react';

import {
  DropdownMenu,
  Icon,
  IconButton,
  List,
  ListItem,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';

import { WidgetsUrlsDto } from 'src/models/widgets.dto';

import { WidgetSmallPopover } from '../WidgetSmallPopover';

import styles from './styles.module.scss';

import { Link } from ':components';

interface WidgetLinkOrMenuProps {
  urls: WidgetsUrlsDto[];
}

export function WidgetMenuOfLinks({
  urls,
}: WidgetLinkOrMenuProps): ReactElement {
  const ref = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState(false);

  const handleTglDropdown = (): void => {
    setOpen(prev => !prev);
  };

  return (
    <>
      <WidgetSmallPopover text='Выбрать раздел'>
        <IconButton
          iconName={Icons.Menu}
          onClick={handleTglDropdown}
          size='medium'
          ref={ref}
        />
      </WidgetSmallPopover>

      {open && (
        <DropdownMenu
          targetElement={ref}
          onOutsideClick={handleTglDropdown}
          align='right'
          positionerClassName={styles.menuPositioner}
        >
          <List className={styles.list}>
            {urls.map(({ url, name, is_internal }) => (
              <ListItem key={name} className={styles.item}>
                <Link
                  to={url}
                  className={styles.withName}
                  noWrapper
                  disableTextDecoration
                >
                  <Typography variant='body2'>{name}</Typography>
                  <Icon
                    size='medium'
                    iconName={
                      is_internal ? Icons.ArrowRight : Icons.OpenInWindow
                    }
                  />
                </Link>
              </ListItem>
            ))}
          </List>
        </DropdownMenu>
      )}
    </>
  );
}
